import './bankStandingOrder.css'
import BankInfoForm from '../bankInfoForm/BankInfoForm'
import { useFetch } from '../../service/useFetch'
import { use, useEffect, useState } from 'react';

export const server = 'https://data.gov.il/api/3/action';
export const resourceId = '2202bada-4baf-45f5-aa61-8c5bad9646d3';


export default function BankStandingOrder({ onCompleted }) {

    const [banks, setBanks] = useState(null);

    const { data } = useFetch(`/datastore_search?resource_id=${resourceId}&distinct=true&fields=Bank_Code%2CBank_Name&include_total=false`, { server: server, });
    useEffect(() => {
        if (data?.result?.records) {
            setBanks(data.result.records.map(bank => ({ value: String(bank.Bank_Code), label: `${bank.Bank_Code} - ${bank.Bank_Name}` })))
        }
    }, [data?.result?.records])
    // fields-flex
    return (
        <div className='bank-standing-order'>
            <BankInfoForm onCompleted={onCompleted} banks={banks} />
        </div>
    )
}


